import Relay from 'react-relay';
import PropTypes from 'prop-types';

export default class UpdateOrganisationOverdueBillIgnore extends Relay.Mutation {
    static propTypes = {
        id: PropTypes.string.isRequired,
        isIgnored: PropTypes.bool.isRequired,
        ignoreSource: PropTypes.string,
    };

    getMutation() { return Relay.QL`mutation { updateOrganisationOverdueBill }`; }
    getFatQuery() { return Relay.QL`fragment on UpdateOrganisationOverdueBillPayload { ok }`; }
    getConfigs() { return [{ type: 'REQUIRED_CHILDREN', children: [this.getFatQuery()] }]; }
    getVariables() { 
        return { 
            id: this.props.id, 
            isIgnored: this.props.isIgnored,
            ignoreSource: this.props.ignoreSource !== undefined ? this.props.ignoreSource : 'manual'
        }; 
    }
}
